import React from 'react';

const withValidSessionIframe = BaseComponent =>
  class WithValidSessionIframe extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        isRedirected: false,
      };

      this.setRef = this.setRef.bind(this);
      this.redirectIfRetailPage = this.redirectIfRetailPage.bind(this);
    }

    componentDidMount() {
      const iframeEl = this.el.getElementsByTagName('iframe')[0];

      this.interval = setInterval(this.redirectIfRetailPage, 200);

      iframeEl.onload = () => {
        clearInterval(this.interval);
      };
    }

    componentWillUnmount() {
      clearInterval(this.interval);
    }

    setRef(el) {
      this.el = el;
    }

    redirectIfRetailPage() {
      try {
        const iframeEl = this.el.getElementsByTagName('iframe')[0];
        const location = iframeEl.contentWindow.location;

        if (
          location.href &&
          (/login.html/.test(location.href) || /subscription.php/.test(location.href))
        ) {
          this.setState({
            isRedirected: true,
          });

          window.location.reload();

          if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }
        }
      } catch (e) {
        // It's a cross-domain error, thus we are in a separate application
        // and we don't need to do anything.
      }
    }

    render() {
      return (
        <div ref={this.setRef} style={{ width: '100%', height: '100%' }}>
          {!this.state.isRedirected && <BaseComponent {...this.props} />}
        </div>
      );
    }
  };

export default withValidSessionIframe;
